import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast, ToastOptions } from "react-toastify";

import { showCustomToast } from "../components/CustomToast";
import { TOAST_SHORT_AUTO_CLOSE_TIME } from "../configs/toast";
import { downloadCollectionYardVisitReceiptsThunk } from "../reducers/collectionYardsReducer";

export const useExportReceipts = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const exportReceipts = async () => {
    const toastId = showCustomToast(t("exportReceiptsMessages.generating"), {
      isLoading: true,
      autoClose: false,
    });

    const res = (await dispatch(downloadCollectionYardVisitReceiptsThunk(t("receipts")))) as any;

    let type: ToastOptions["type"] = "success";
    let message = t("exportReceiptsMessages.success");

    if (res?.error?.message?.includes("404")) {
      message = t("exportReceiptsMessages.warning");
      type = "warning";
    } else if (res?.error) {
      type = "error";
      message = t("exportReceiptsMessages.error");
    }

    toast.update(toastId, {
      render: message,
      type,
      isLoading: false,
      autoClose: TOAST_SHORT_AUTO_CLOSE_TIME,
    });
  };

  return { exportReceipts };
};
